import React, { Component } from 'react';
import { Divider, Switch, Button, NumericInput } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class MasteryLevel extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      CHMaxMasteryLevel: 300,
      CHSkillsForEUCharacters: true,
      CHMasteryForEUCharacters: true,
      EUMaxMasteryLevel: 300,
      EUMasteryPerLevel: 2,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          Mastery Level Settings
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td>CH Maximum Mastery Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  style={{ width: '120px' }}
                  value={this.state.CHMaxMasteryLevel}
                  placeholder="Type a level..."
                  onValueChange={this.handleChange('CHMaxMasteryLevel')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td style={{ minWidth: '150px' }}>CH Skills For EU Characters</td>
              <td>
                <Switch
                  checked={this.state.CHSkillsForEUCharacters}
                  {...SwitchOnOff}
                  onChange={this.handleChange('CHSkillsForEUCharacters')}
                />
              </td>
            </tr>

            <tr>
              <td>CH Mastery System For EU Characters</td>
              <td>
                <Switch
                  checked={this.state.CHMasteryForEUCharacters}
                  {...SwitchOnOff}
                  onChange={this.handleChange('CHMasteryForEUCharacters')}
                />
              </td>
            </tr>

            <tr>
              <td>EU Maximum Mastery Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.CHMasteryForEUCharacters}
                  style={{ width: '120px' }}
                  value={this.state.EUMaxMasteryLevel}
                  placeholder="Type a level..."
                  onValueChange={this.handleChange('EUMaxMasteryLevel')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>EU Mastery Per Level</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={this.state.CHMasteryForEUCharacters}
                  style={{ width: '120px' }}
                  value={this.state.EUMasteryPerLevel}
                  placeholder="Type a number..."
                  onValueChange={this.handleChange('EUMasteryPerLevel')}
                  className="mb-4"
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
